
import { Component, Vue, Prop } from 'vue-property-decorator'

@Component
export default class PickHeader extends Vue {
  @Prop({ type: String, required: true, default: 'Scan QR Code' }) readonly title!: string

  @Prop({ type: String, required: true }) readonly currentStep!: string

  @Prop({ type: Number, default: 0 }) readonly pickPage!: number

  @Prop({ type: Number, default: 0 }) readonly productsLength!: number

  onCancel (): void {
    this.$buefy.dialog.confirm({
      message: 'ต้องการยกเลิกการหยิบใช่หรือไม่',
      canCancel: true,
      confirmText: 'ยกเลิก',
      cancelText: 'หยิบต่อ',
      type: 'is-danger',
      onConfirm: async () => {
        this.$emit('cancelPick')
      }
    })
  }

  handleHomePage (): void {
    if (this.productsLength > 0) {
      this.$buefy.dialog.confirm({
        message: 'มีข้อมูลที่ยังไม่บันทึก หากออกจากหน้านี้ข้อมูลจะหายไป ต้องการออกจากหน้าหรือไม่',
        canCancel: true,
        confirmText: 'ต้องการ',
        cancelText: 'ยกเลิก',
        type: 'is-danger',
        onConfirm: async () => {
          this.$emit('cancelPick')
          this.$router.push({ name: 'Home' })
        }
      })
    } else {
      this.$router.push({ name: 'Home' })
    }
  }
}
